import { Component, inject,OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ImpersonateService } from '../../../services/impersonate.service';
import { LoadingStore } from '../../../stores/loading.store';
import { getStorageObject } from '../../../utils/storage-manager';

@Component({
  selector: 'app-impersonate-modal',
  templateUrl: './impersonate-modal.component.html',
  styleUrls: ['./impersonate-modal.component.scss']
})
export class ImpersonateModalComponent implements OnInit {
  private builder = inject(FormBuilder);
  private impersonateService = inject(ImpersonateService);
  private loading = inject(LoadingStore);

  /**
   * Form to send the email to impersonate
   */
  emailForm: FormGroup;

  /**
   * Whether checkbox is checked
   */
  activateLogs = false;

  /**
   * Whether to activate logs for the impersonated user
   */
  canViewLogs = false;

  constructor() {
    this.emailForm = this.builder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    this.canViewLogs = getStorageObject('userData')?.roles.includes('admin');
  }

  async getToken(): Promise<void> {
    if (!this.emailForm.valid) {
      return;
    }
    try {
      this.loading.start();
      await this.impersonateService.getToken(this.emailForm.value.email, this.activateLogs);
    } finally {
      this.loading.stop();
    }
  }
}
